import { FilterFilled } from '@ant-design/icons';
import { Checkbox, Col, Popover, Row } from 'antd';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import { useState } from 'react';

export const ModalCheckBox = <T extends CheckboxValueType>({
  defaultValue,
  value,
  onChange,
  title,
  items,
  isCenter = true,
}: Props<T>) => {
  const [isVisible, setIsVisible] = useState(false);

  const checkboxItem = (cbi: { value: T; label: string }) => (
    <Row key={cbi.label}>
      <Col>
        <Checkbox value={cbi.value}>{cbi.label}</Checkbox>
      </Col>
    </Row>
  );

  const checkbox = (
    <Checkbox.Group
      defaultValue={defaultValue}
      onChange={(vals) => onChange(vals as T[])}
      value={value}
    >
      {items.map(checkboxItem)}
    </Checkbox.Group>
  );

  return (
    <Popover
      content={checkbox}
      trigger="click"
      open={isVisible}
      onOpenChange={setIsVisible}
    >
      <div
        className="sort-button min-width-90"
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: isCenter ? 'center' : 'space-between',
        }}
      >
        {title}
        <FilterFilled
          style={{ color: '#BFBFBF', marginLeft: '10px', fontSize: '12px' }}
        />
      </div>
    </Popover>
  );
};

type Props<T extends CheckboxValueType> = {
  defaultValue?: T[];
  value?: T[];
  onChange: (checkedValue: T[]) => void;
  title: string;
  items: {
    value: T;
    label: string;
  }[];
  isCenter?: boolean;
};
